import { alpha, Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MITable from 'components/common/grid/MITable';
import { WorkflowInfoPrepareData } from 'components/alert-rule-popup/AlertRuleDataProcessor';
import { alertRuleAPI } from 'api/alert-wizard';
import { useTranslation } from 'react-i18next';

interface AlertRuleWorkflowInfoProps {
    workflowId: string;
    workflowInstanceId?: number;
}

export default function AlertRuleWorkflowInfo(props: AlertRuleWorkflowInfoProps) {
    const { workflowId, workflowInstanceId } = props;
    const [workflowInfo, setWorkflowInfo] = useState<any>();
    const { t } = useTranslation(['components/alert-rule-popup/alert_rule_popup']);

    useEffect(() => {
        alertRuleAPI
            .getWorkflowInfo(String(workflowId), workflowInstanceId)
            .then((response) => {
                setWorkflowInfo(WorkflowInfoPrepareData(response.data));
            })
            .catch(() => {
                setWorkflowInfo(WorkflowInfoPrepareData({}));
            });
    }, []);

    const statusGridColumns = ['status', 'state'].map((columnKey) => {
        return {
            name: columnKey,
            title: t('form.workflow_info.status_grid.column_' + columnKey),
            resizable: false,
        };
    });

    const roleGridColumns = ['role', 'create', 'update'].map((columnKey) => {
        return {
            name: columnKey,
            title: t('form.workflow_info.role_grid.column_' + columnKey),
            resizable: false,
        };
    });

    if (!workflowInfo) return null;

    return (
        <>
            <Box sx={{ mt: 2 }}>
                <Typography
                    variant="heading"
                    sx={{ borderBottomColor: (theme) => alpha(theme.palette.primary.main, 0.4), mb: 1 }}
                >
                    {t('form.workflow_info.statuses_title')}
                </Typography>
                <MITable
                    autoHeight
                    data={workflowInfo.statusGridData}
                    height={200}
                    columns={statusGridColumns}
                    massActionsConfig={{ enabled: false }}
                    gridName={'alert_rule_workflow_status'}
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <Typography
                    variant="heading"
                    sx={{ borderBottomColor: (theme) => alpha(theme.palette.primary.main, 0.4), mb: 1 }}
                >
                    {t('form.workflow_info.def_notif_settings_title')}
                </Typography>
                <Box
                    sx={{
                        border: '1px solid',
                        borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                        px: 1.5,
                        py: 1,
                        backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.02),
                        borderRadius: '4px',
                        mb: 1,
                    }}
                >
                    <Box>
                        {t('form.workflow_info.auto_close_label')}{' '}
                        {workflowInfo.workflow.auto_close_when_not_applied_ind}
                    </Box>
                    <Box>
                        {t('form.workflow_info.acknowledgement_label')}{' '}
                        {workflowInfo.workflow.acknowledgment_required_ind}
                    </Box>
                </Box>
                <MITable
                    autoHeight
                    data={workflowInfo.roleGridData}
                    height={200}
                    columns={roleGridColumns}
                    massActionsConfig={{ enabled: false }}
                    gridName={'alert_rule_workflow_role'}
                />
            </Box>
        </>
    );
}
